import {Card} from '@mui/material'
import {css} from '@emotion/react'
import {useTranslations} from 'next-intl'

export default function ProgressBar({ timeLeft, totalTime, ...props }) {
  const styles = {
    root: css`
      width: 100%;
      height: 22px;
      overflow: hidden;
      position: relative;
    `,

    bar: css`
      height: 100%;
      background: #76c7c0;
      transition: width 0.1s linear;
    `,

    barContainer: css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
    `,

    label: css`
      margin-right: 4px;
    `,

    number: css`

    `
  }
  const t = useTranslations()

  const progressWidth = (timeLeft / totalTime) * 100;

  return (
    <Card css={styles.root} {...props}>
      <div
        css={styles.bar}
        style={{
          width: `${progressWidth}%`
        }}
      />
      <div css={styles.barContainer}>
        <div>
          <span css={styles.label}>{t('kana-connect.game-time-label')}</span>
          <span css={styles.number}>{timeLeft}</span>
        </div>
      </div>
    </Card>
  );
}
